// import PersonalIndex from '../../containers/themes/zh/reports/PersonalIndex.jsx'
//
// import LotteryReport from '../../containers/pc-day/reports/LotteryReport.jsx';
// import TeamManeger from '../../containers/pc-day/reports/TeamManeger.jsx';
// import DailySalary from '../../containers/pc-day/reports/dailySalary/DailySalary.jsx';
// import MySalary from '../../containers/pc-day/reports/dailySalary/MySalary.jsx';
// import SubContract from '../../containers/pc-day/reports/dailySalary/SubContract.jsx';
// import SubSalary from '../../containers/pc-day/reports/dailySalary/SubSalary.jsx';
import PersonalIndex from '../../containers/pc-day/reports/PersonalIndex.jsx';
import WalletManagement from '../../containers/pc-day/reports/WalletManagement.jsx';
/**
 * 报表菜单
 * @type {Array}
 */
export const MENU = [
    {
        type: 'team',
        name: '管理中心',
        menus: [
            {
                id:599,
                name: '团队管理',
                location: 'team/management/index'
            },
            {
                id:519704,
                name: '极速充提订单',
                location: 'user/getopflists?new=1&version=x'
            },
            {
                id:340725,
                name: '日工资',
                location: 'team/daliy_compact/my',
                children:[
                    {
                        name: '我的日工资',
                        id:340726,
                        // component: < MySalary/>,
                        location: 'team/daliy_compact/my',
                    },
                    {
                        id:340731,
                        name: '下级契约',
                        location: 'team/daliy_compact/myteam',
                        // component:<SubContract/>
                    },
                    {
                        id:340732,
                        name: '下级日工资',
                        location: 'team/daliy_compact/teamsalary',
                        // component:<SubSalary/>
                    }
                ]
            },
            {
                id:344438,
                name: '真人返水契约',
                location: 'team/casino_compact/userlive',
                children:[
                    {
                        id:344439,
                        name: '真人返水',
                        location: 'team/casino_compact/userlive'
                    },
                    {
                        id:344440,
                        name: '下级契约',
                        location: 'team/casino_compact/teamcompactlive'
                    },
                    {
                        id:344441,
                        name: '下级返水',
                        location: 'team/casino_compact/teamsalarylive'
                    }
                ]
            },
            {
                id:344445,
                name: '体育返水契约',
                location: 'team/sport_compact/usersport',
                children:[
                    {
                        id:344446,
                        name: '体育返水',
                        location: 'team/sport_compact/usersport'
                    },
                    {
                        id:344447,
                        name: '下级契约',
                        location: 'team/sport_compact/teamcompactsport'
                    },
                    {
                        id:344448,
                        name: '下级返水',
                        location: 'team/sport_compact/teamsalarysport'
                    }
                ]
            },
            {
                id:347883,
                name: '彩票契约分红',
                location: 'team/pink_compact/index'
            }
        ]
    },
    {
        type: 'personal',
        name: 'personal management',
        location: 'personal/management/index',
        menus: null,
        component:<PersonalIndex/>
    },
    {
        type: 'reports',
        name: '报表管理',
        menus:[
            {
                id:101642,
                name: '彩票报表',
                location: 'reports/lottery/index',
                // component:<LotteryReport/>,
            },
            {
                id:347873,
                name: '真人老虎机',
                location: 'reports/casino/index'

            },
            {
                id:347875,
                name: '体育报表',
                location: 'reports/sport/index'

            },
            {
                id:347881,
                name: '真人电子体育',
                location: 'reports/eprofitloss/index'
            }
        ]
    },
    {
      type: 'walletManagement',
      name: '钱包管理',
      location: 'reports/wallet-management/index',
      menus: null,
      component:<WalletManagement/>
  },
]

export const MENU_DF = [
  {
    type: 'team',
    name: '管理中心',
    menus: [
      {
        id:599,
        name: '团队管理',
        location: 'team/management/index'
      },
      {
        id:340725,
        name: '日工资',
        location: 'team/daliy_compact/my',
        children:[
          {
            name: '我的日工资',
            id:340726,
            // component: < MySalary/>,
            location: 'team/daliy_compact/my',
          },
          {
            id:340731,
            name: '下级契约',
            location: 'team/daliy_compact/myteam',
            // component:<SubContract/>
          },
          {
            id:340732,
            name: '下级日工资',
            location: 'team/daliy_compact/teamsalary',
            // component:<SubSalary/>
          }
        ]
      },
      {
        id:347883,
        name: '彩票契约分红',
        location: 'team/pink_compact/index'
      }
    ]
  },
  {
    type: 'personal',
    name: 'personal management',
    location: 'personal/management/index',
    menus: null,
    component:<PersonalIndex/>
  },
  {
    type: 'reports',
    name: '报表管理',
    menus:[
      {
        id:101642,
        name: '彩票报表',
        location: 'reports/lottery/index',
        // component:<LotteryReport/>,
      }
    ]
  }
]


var MENUS_FLAG;
switch(window.vers){
  case 'hy':  // 恒耀
    MENUS_FLAG = MENU;
    break;
  case 'zh':  // 众合
    MENUS_FLAG = MENU;
    break;
  case 'df':  // 达福
    MENUS_FLAG = MENU_DF;
    break;
  default:
    MENUS_FLAG = MENU;
}
export const MENUS = MENUS_FLAG;